import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemPanel } from '../item-panel/item-panel';
import { Item, SelectionEvent as PanelSelectionEvent } from '../item-panel/item-panel.model';

// The specific interface for THIS component's data
export interface PriceFilter {
  id: number;
  label: string;
  minValue?: number;
  maxValue?: number;
  selected?: boolean;
}

// THIS COMPONENT'S OWN event payload interface.
export interface PriceFilterSelectionEvent {
  source: PriceFilter | null;
  selected: PriceFilter[];
}

@Component({
  selector: 'app-price-filter-panel',
  imports: [
    ItemPanel
  ],
  templateUrl: './price-filter-panel.html',
  styleUrl: './price-filter-panel.scss'
})
export class PriceFilterPanel implements OnInit {
  @Input() title: string = '';
  @Input() priceFilterList: PriceFilter[] = [];
  /** THIS COMPONENT'S OWN OUTPUT, using its own specific event type. */
  @Output() selectionChanged = new EventEmitter<PriceFilterSelectionEvent>();

  panelItems: Item[] = [];

  ngOnInit(): void {
    // This mapping remains the same
    this.panelItems = this.priceFilterList.map(priceFilter => ({
      id: priceFilter.id,
      label: priceFilter.label,
      selected: priceFilter.selected ?? false,
    }));
  }

  /** Handles the generic event from the child panel and maps it to a specific event. */
  onPanelSelectionChange(panelEvent: PanelSelectionEvent): void {
    // 1. Find the full records for all selected items
    const selectedIds = new Set(panelEvent.selectedItems.map(item => item.id));
    const selectedFilters = this.priceFilterList.filter(priceFilter =>
      selectedIds.has(priceFilter.id)
    );

    // 2. Find the full record for the source item that was toggled
    const sourceFilter = panelEvent.source
      ? this.priceFilterList.find(p => p.id === panelEvent.source?.id) ?? null
      : null;

    // 3. Construct and emit THIS component's own, specific event payload
    this.selectionChanged.emit({
      source: sourceFilter,
      selected: selectedFilters,
    });
  }
}
